// extracted by mini-css-extract-plugin
export default {"tooltip":"PortsTooltips_tooltip__B1hdf"};